import { type ValidateFunction } from 'ajv';

class BadRequestError extends Error {
  constructor(message: string) {
    super(message);
    this.status = 400;
    this.name = 'BadRequestError';
    this.cause = this.cause ?? message;
  }

  readonly status: number;
}

class NotFoundError extends Error {
  constructor(message: string) {
    super(message);
    this.status = 404;
    this.name = 'NotFoundError';
    this.cause = this.cause ?? message;
  }

  readonly status: number;
}

class ForbiddenError extends Error {
  constructor(message: string) {
    super(message);
    this.status = 403;
    this.name = 'ForbiddenError';
    this.cause = this.cause ?? message;
  }

  readonly status: number;
}

class InternalServerError extends Error {
  constructor(message: string) {
    super(message);
    this.status = 500;
    this.name = 'InternalServerError';
  }

  readonly status: number;
}

class UnauthorizedError extends Error {
  constructor(message: string) {
    super(message);
    this.status = 401;
    this.name = 'UnauthorizedError';
  }

  readonly status: number;
}

class BodyValidationError extends BadRequestError {
  constructor(errors: ValidateFunction['errors']) {
    super('Request body validation failed');
    this.name = 'BodyValidationError';

    this.cause = errors;
  }
}

class QueryValidationError extends BadRequestError {
  constructor(errors: ValidateFunction['errors']) {
    super('Request query validation failed');
    this.name = 'QueryValidationError';
    this.cause = errors;
  }
}

export {
  BadRequestError,
  BodyValidationError,
  ForbiddenError,
  InternalServerError,
  NotFoundError,
  QueryValidationError,
  UnauthorizedError,
};
